"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUB_MENU_PADDING = exports.SUB_MENU_ITEM_MARGIN = exports.SUB_MENU_ITEM_HEIGHT = void 0;
exports.SUB_MENU_ITEM_HEIGHT = 40;
exports.SUB_MENU_ITEM_MARGIN = 4;
exports.SUB_MENU_PADDING = 12;
